export type LocaleDict = Record<string, string>;

export type JobTagLocation = {
	slug?: string;
	name?: LocaleDict;
};

export type JobAddressable = {
	tags?: {
		office_location?: {
			data?: JobTagLocation[];
		};
	};
};

export function normalizeLocationSlug(value: string): string {
	return value.replace(/-\d+$/, "");
}

export function resolveLocalizedValue(value: LocaleDict | undefined, locale: string): string {
	if (!value) return "";
	return value[locale] || value["en"] || value["hu"] || value["ro"] || "";
}

export function getJobOfficeLocations(job: JobAddressable): JobTagLocation[] {
	return job.tags?.office_location?.data || [];
}

export function createCityAddressResolver(params: { citySlug: string; cityName: () => string; locale: () => string }) {
	const normalizedCitySlug = normalizeLocationSlug(params.citySlug);

	return (job: JobAddressable): string => {
		const locations = getJobOfficeLocations(job);
		const matchedLocation = locations.find(
			(location) => normalizeLocationSlug(String(location.slug || "")) === normalizedCitySlug
		);

		if (!matchedLocation) {
			return params.cityName();
		}

		return resolveLocalizedValue(matchedLocation.name, params.locale()) || params.cityName();
	};
}

export function createCountyAddressResolver(params: {
	countyLocationSlugSet: () => Set<string>;
	locale: () => string;
}) {
	return (job: JobAddressable): string => {
		const locations = getJobOfficeLocations(job);

		const names = locations
			.filter((location) =>
				params.countyLocationSlugSet().has(normalizeLocationSlug(String(location.slug || "")))
			)
			.map((location) => resolveLocalizedValue(location.name, params.locale()))
			.filter(Boolean)
			.filter((name, index, source) => source.indexOf(name) === index);

		return names.join(", ");
	};
}
